import { useState } from 'react';

const faqs = [
  {
    question: '什么是无码平台？和传统开发有什么区别？',
    answer: '无码平台是一种可视化应用开发工具，允许用户通过拖拽组件、配置参数的方式快速构建软件应用，无需编写代码。相比传统开发模式（数周至数月），无码开发可以将开发周期缩短至数天甚至数小时，同时大幅降低对专业技术人员的依赖，让业务人员也能直接参与应用搭建。',
  },
  {
    question: '无码平台适合哪些场景？有没有功能限制？',
    answer: '无码平台适用于企业管理系统（CRM、ERP、OA）、数据收集与分析、自动化工作流、企业官网与电商平台等多种场景。对于复杂的定制化需求，平台也提供了开放API和自定义代码扩展能力，确保在简化开发的同时不牺牲灵活性。绝大多数企业级应用需求都可以通过无码平台满足。',
  },
  {
    question: '使用无码开发的应用数据安全吗？',
    answer: '绝对安全。无码平台采用多重安全机制保障数据安全：数据传输全程加密（TLS 1.3）、数据库存储加密、RBAC精细权限控制、完整的操作审计日志。平台已通过ISO 27001信息安全管理体系认证，并支持私有化部署，满足金融、医疗等高合规要求行业的严格标准。',
  },
  {
    question: '无码平台支持哪些终端？可以生成APP吗？',
    answer: '无码平台支持一次设计、多端运行。你搭建的应用可以同时在PC端（Web）、移动端（H5响应式）、平板端上使用，还可以一键生成微信小程序。对于需要发布到应用商店的原生APP需求，平台也提供了PWA（渐进式Web应用）打包方案，用户可以将应用添加到手机桌面，获得接近原生APP的体验。',
  },
  {
    question: '如何开始使用无码？需要培训吗？',
    answer: '注册后即可免费开始使用。平台提供丰富的模板库和图文教程，大多数人可以在10分钟内完成第一个应用的搭建。对于企业用户，我们还提供专属的客户成功经理一对一指导、在线培训课程和定期的产品更新培训。您也可以随时查阅帮助文档或联系在线客服获取支持。',
  },
  {
    question: '无码平台的定价是怎样的？',
    answer: '无码提供灵活的定价方案：个人版完全免费，适合学习和小型项目；专业版按用户数收费，提供更多功能和资源额度；企业版支持私有化部署、定制化开发和专属服务。具体价格请通过官网联系我们的商务团队，我们将根据您的实际需求提供最合适的方案。',
  },
];

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-50 text-primary-700 text-sm font-medium mb-4">
            常见问题
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            你可能会问的问题
          </h2>
          <p className="text-foreground-600 text-base leading-relaxed">
            快速了解无码平台的核心能力与使用方式
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
              >
                <span className="text-base font-semibold text-foreground-950 pr-4">{faq.question}</span>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300 flex-shrink-0 ${
                  openIdx === idx ? 'bg-primary-100 text-primary-600 rotate-45' : 'bg-secondary-100 text-foreground-600'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`px-6 transition-all duration-300 overflow-hidden ${
                  openIdx === idx ? 'pb-5 max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}